import { gql } from '@apollo/client';

export const GET_FAVORITE_BY_JW_MEDIA_ID = gql`
  query getFavouriteByJWmediaid($jwMediaId: String!) {
    getFavouriteByJWmediaid(jwMediaId: $jwMediaId) {
      fId
      fJwMediaId
      fUpdatedAt
      fUserId
      fCreatedAt
    }
  }
`;

export const GET_FAVOURITES_LIST = gql`
  query getFavouritesList($first: Int!, $offset: Int!) {
    getFavouritesList(first: $first, offset: $offset) {
      nodes {
        fId
        fJwMediaId
        fCreatedAt
        fUpdatedAt
        fUserId
      }
      totalCount
    }
  }
`;

export type FavoriteNode = {
  fId: string;
  fJwMediaId: string;
  fCreatedAt: string;
  fUpdatedAt: string;
  fUserId: string;
};

export type GetFavoriteByJWMediaIdData = {
  getFavouriteByJWmediaid: FavoriteNode | null;
};

export type GetFavouritesListData = {
  getFavouritesList: {
    nodes: FavoriteNode[];
    totalCount: number;
  };
};
